import React from 'react';
import { useState } from 'react';
import { BsBagCheck, BsTrash } from 'react-icons/bs';
import { Form, Button, Table } from 'react-bootstrap';


const Order = ({ order, handleRemoveProduct, handleQuantityChange, handleSubmitOrder, handleExtraGlassesChange }) => {
    const [isValid, setIsValid] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleQuantityChangeForm = (index, quantity) => {

        handleQuantityChange(index, quantity);
    }

    const handleQuantityValidateForm = (index, quantity) => {
        // Validate quantities
        const quantities = order.orderLines.map(line => line.quantity)
        const allValid = quantities.every(qty => qty > 0 && qty < 11 && Number.isInteger(Number(qty)));
        setIsValid(allValid);
    }

    const handleSubmit = (event) => {
        setIsSubmitting(true);
        event.preventDefault();
        if (isValid) {
            handleSubmitOrder(order);
        }

        // block the submit button for 2 seconds to prevent duplicate orders
        setTimeout(() => {
            setIsSubmitting(false);
        }, 2000);
    };

    const handleExtraGlassesChangeForm = (quantity) => {
        // change value
        handleExtraGlassesChange(quantity);

        // Validate value
        const isValid = quantity >= 0 && quantity < 11 && Number.isInteger(Number(quantity));
        setIsValid(isValid);
    }

    const handleExtraGlassesValidateForm = (quantity) => {
        // Validate value
        const isValid = quantity >= 0 && quantity < 11 && Number.isInteger(Number(quantity));
        setIsValid(isValid);
    }

    return (
        <div>
            {(order.orderLines.length > 0) ?
                <Form onSubmit={handleSubmit}>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th scope="col">Product</th>
                                <th scope="col" style={{ width: '20%' }}>#</th>
                                <th scope="col">Prijs</th>
                                <th scope="col">Actie</th>
                            </tr>
                        </thead>
                        <tbody>
                            {order.orderLines.map((line, index) => (
                                <tr key={index}>
                                    <td>{line.product.productName}</td>
                                    <td>
                                        <Form.Control
                                            id={'quantity' + index.toString()}
                                            type="number"
                                            min="1"
                                            max="10"
                                            required="required"
                                            value={line.quantity}
                                            onChange={(e) => handleQuantityChangeForm(index, e.target.value)}
                                            onblur={(e) => handleQuantityValidateForm(index, e.target.value)}
                                        />
                                    </td>
                                    <td>{parseFloat(line.product.price * line.quantity).toFixed(2)}€
                                    </td>
                                    <td>
                                        <Button variant="danger" onClick={() => handleRemoveProduct(index)}>
                                            <BsTrash />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                            <tr>
                                <td>Extra glazen</td>
                                <td>
                                    <Form.Control
                                        id="extraGlasses"
                                        type="number"
                                        min="0"
                                        max="10"
                                        required="required"
                                        value={order.extraGlasses}
                                        onChange={(e) => handleExtraGlassesChangeForm(e.target.value)}
                                        onBlur={(e) => handleExtraGlassesValidateForm(e.target.value)}
                                    />
                                </td>
                                <td colSpan="2"></td>
                            </tr>
                            <tr>
                                <td colSpan="2">Totaal</td>
                                <td>{parseFloat(order.orderLines.reduce((total, line, index) => total + line.product.price * line.quantity, 0)).toFixed(2)}€
                                    </td>
                                <td>
                                    <Button variant="primary" type="submit" disabled={isSubmitting}>
                                        <BsBagCheck />Bestel
                                    </Button>
                                </td >
                            </tr>
                        </tbody>
                    </Table>
                </Form>
                : ""}
        </div>
    );
};

export default Order;